<template>
    <!--Feature One Start-->
    <section class="feature-one">
            <div class="container">
                <div class="row">

                    
                    <!--div class="col-xl-6 col-lg-6  wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="feature-one__single">
                            <div class="feature-one__single-bg"
                                style="background-image: url(assets/images/shapes/feature-edit.png);"></div>
                            <div class="feature-one__top">
                                <div class="feature-one__top-inner">
                                    <div class="feature-one__top-icon"-->
                                        <!-- <span class="icon-help"></span> -->
                                        <!--img src="assets/images/other/ieh.png" alt="">
                                    </div>
                                    <div class="feature-one__top-title-box">
                                        <h3 class="feature-one__top-title"><a style="color: #010101;" href="#">Electricidad</a></h3>
                                    </div>
                                </div>
                            </div-->
                            <!-- <p class="feature-one__text">Mauris feugiat at orci ac congue. mauris ut <br> lacus quis
                                proin
                                diam.</p> -->
                            <!--ul class="list list-unstyled feature-one__point espacio">
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Mantenimientos eléctricos.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Reparación de instalaciones eléctricas.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Instalaciones de baja y media tensión.</p>
                                    </div>
                                </li>
                            </ul>
                            <router-link to="/electric"><a href="#" class="thm-btn feature-one__btn" style="color: #283734;">Ver detalles</a></router-link>
                        </div>
                    </div-->

                    <div class="col-xl-6 col-lg-6  wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="feature-one__single feature-one__single--two">

                            <div class="feature-one__single-bg"
                                style="background-image: url(assets/images/shapes/feature-edit.png);"></div>
                            <div class="feature-one__top">
                                <div class="feature-one__top-inner">
                                    <div class="feature-one__top-icon feature-one__top-icon--two">
                                        <!-- <span class="icon-gift-box"></span> -->
                                        <img src="assets/images/other/ieh.png" alt="">
                                    </div>
                                    
                                    <div class="feature-one__top-title-box">
                                        <h3 class="feature-one__top-title"><a style="color: #010101;" href="#">Electricidad</a></h3>
                                    </div>
                                </div>
                            </div>
                            <!-- <p class="feature-one__text">Mauris feugiat at orci ac congue. mauris ut <br> lacus quis
                                proin
                                diam.</p> -->
                            <ul class="list-unstyled feature-one__point espacio2">
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Mantenimientos eléctricos.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Reparación de instalaciones eléctricas.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Instalaciones de baja y media tensión.</p>
                                    </div>
                                </li>
                            </ul>
                            <router-link to="/electric"><a href="#" class="thm-btn feature-one__btn" style="color: #283734; margin-bottom: 8px; margin-top: 16px;">Ver detalles</a></router-link>
                           
                        </div>
                    </div>

                    <div class="col-xl-6 col-lg-6  wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="feature-one__single feature-one__single--two" style ="padding: 20px 50px 38px !important;">

                            <div class="boton">
                                <a href="http://iehcontrol.com" target="_blank" class="bnt-top thm-btn feature-one__btn">Acceder</a>
                            </div>

                            <div class="feature-one__single-bg"
                                style="background-image: url(assets/images/shapes/feature-edit.png);"></div>
                            <div class="feature-one__top">
                                <div class="feature-one__top-inner">
                                    <div class="feature-one__top-icon feature-one__top-icon--two">
                                        <!-- <span class="icon-gift-box"></span> -->
                                        <img src="assets/images/other/ieh.png" alt="">
                                    </div>
                                    
                                    <div class="feature-one__top-title-box">
                                        <h3 class="feature-one__top-title"><a style="color: #010101;" href="#">Control</a></h3>
                                    </div>
                                </div>
                            </div>
                            <!-- <p class="feature-one__text">Mauris feugiat at orci ac congue. mauris ut <br> lacus quis
                                proin
                                diam.</p> -->
                            <ul class="list-unstyled feature-one__point espacio2">
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Pruebas de bombeo.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Sistema de Riego tecnificado.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p style="color: #010101;">Instalaciones de bombas de pozo profundo</p>
                                    </div>
                                </li>
                            </ul>
                            <router-link to="/iehcontrol"><a href="#" class="thm-btn feature-one__btn" style="color: #283734; margin-bottom: 8px; margin-top: 16px;">Ver detalles</a></router-link>
                           
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Feature One End-->
  
  </template>
    <style>
        .espacio{
            margin-top: 40px;
        }

        .espacio2{
            margin-top: 40px;
            margin-bottom: 30px;
        }
        .feature-one {
            padding: 60px 60px !important;
        }

        .boton{
           margin-bottom: 0px;
           margin-top: 0px;
           margin-left: 340px;
        }

        .bnt-top{
            color: #283734 !important; 
            border-radius: 22px;
            height: 30px !important; 
            padding: 2px 24px 2px;
            font-size: 12px;
        }

        .bnt-top:hover {
            color: var(--oxpins-white);
        }

        @media only screen and (max-width: 1024px){
            .feature-one {
                padding: 60px 20px !important;
            }
            .boton{
                margin-left: 275px;
            }

        }

        @media only screen and (max-width: 768px){
                .feature-one {
                padding: 60px 20px !important;
            }

            .feature-one__point li .text p {
                font-size: 22px;
            }

            .thm-btn{
                font-size: 16px;
            }

            .boton{
                margin-left: 500px;
            }

            .bnt-top{
                color: #283734 !important; 
                border-radius: 22px;
                height: 30px !important; 
                padding: 1px 24px 1px;
                font-size: 12px;
            }

        }    

        
        @media only screen and (max-width: 414px) {
            .feature-one {
                padding: 60px 0px !important;
            }
            .feature-one__point li .text p {
                font-size: 12px;
            }

            .list{
                margin-left: 30px;
            }
            .feature-one__top-inner {
                flex-direction: column;
                align-items: center;
            }

            .thm-btn {
                font-size: 13px;
            }

            .boton{
                margin-left: 220px;
            }

            .bnt-top{
                color: #283734 !important; 
                border-radius: 22px;
                height: 20px !important; 
                padding: 1px 16px 2px;
                font-size: 12px;
                line-height: 20px !important;
            }
                    
        }

        @media only screen and (max-width: 390px){
            .feature-one__point li .text p {
                font-size: 11px;
            }

            .boton{
                margin-left: 200px;
            }

            .bnt-top{
                color: #283734 !important; 
                border-radius: 22px;
                height: 20px !important; 
                padding: 2px 16px 2px;
                font-size: 12px;
            }
        }

        @media only screen and (max-width: 375px) {
            .feature-one{
                padding: 2px 2px !important;
            }
            .feature-one__point li .text p {
                font-size: 10px;
            }
            .feature-one__top-inner {
                align-items: center;
            }
            .thm-btn {
                font-size: 11px;
            }

            .boton{
                margin-left: 188px;
            }


           
        }

        @media only screen and (max-width: 320px){
            .feature-one{
                padding: 2px 2px !important;
            }
            .feature-one__point li .text p {
                font-size: 7px;
            }
            .feature-one__top-inner {
                align-items: center;
            }
            .thm-btn {
                font-size: 10px;
            }
            .feature-one__btn {
                padding: 7px 30px 7px;
            }

            .list {
                margin-left: 30px;
            }

            .boton{
                margin-left: 130px;
            }

            .bnt-top{
                color: #283734 !important; 
                border-radius: 22px;
                height: 20px !important; 
                padding: 2px 16px 2px;
                font-size: 12px;
            }

        }
    </style>
  <script>
  </script>